var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCmdHide16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Artwork",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    enableBackground: "new 0 0 16 16",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -2.6,
    y: 7.5,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -3.3137 8)",
    className: "aw-theme-iconOutline",
    fill: "#464646",
    width: 21.2,
    height: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "aw-theme-iconOutline",
    fill: "#464646",
    d: "M2.9,11.6c-0.1,0-0.2,0-0.3-0.1c-1-0.8-1.7-1.9-2.3-3.1C0.1,8.2,0.1,8,0.2,7.9c1.6-3.2,4.6-5.2,7.7-5.2 c0.9,0,1.7,0.2,2.6,0.4c0.3,0.1,0.4,0.4,0.3,0.6c-0.1,0.3-0.4,0.4-0.6,0.3C9.4,3.8,8.7,3.7,7.9,3.7c-2.7,0-5.3,1.7-6.7,4.4 c0.5,1,1.2,1.9,2,2.6c0.2,0.2,0.2,0.5,0,0.7C3.1,11.5,3,11.6,2.9,11.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "aw-theme-iconOutline",
    fill: "#464646",
    d: "M7.9,13.6c-0.9,0-1.9-0.2-2.7-0.5c-0.3-0.1-0.4-0.4-0.3-0.6C5,12.2,5.3,12,5.5,12.1c0.8,0.3,1.6,0.4,2.4,0.4 c2.7,0,5.3-1.7,6.7-4.4c-0.5-1-1.3-2-2.1-2.7c-0.2-0.2-0.2-0.5-0.1-0.7c0.2-0.2,0.5-0.2,0.7-0.1c1,0.9,1.8,1.9,2.5,3.2 c0.1,0.1,0.1,0.3,0,0.4C14.1,11.6,11.1,13.6,7.9,13.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "aw-theme-iconOutline",
    fill: "#464646",
    d: "M5.1,9.3C4.9,9.3,4.7,9.2,4.6,9C4.5,8.7,4.5,8.4,4.5,8.1c0-1.9,1.5-3.5,3.4-3.5c0.3,0,0.6,0,0.9,0.1 c0.3,0.1,0.4,0.4,0.3,0.6C9.1,5.6,8.8,5.8,8.6,5.7C8.4,5.7,8.1,5.6,7.9,5.6c-1.3,0-2.4,1.1-2.4,2.5c0,0.2,0,0.4,0.1,0.6 C5.7,9,5.5,9.3,5.2,9.3C5.2,9.3,5.1,9.3,5.1,9.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "aw-theme-iconOutline",
    fill: "#464646",
    d: "M7.9,11.6c-0.4,0-0.7-0.1-1.1-0.2c-0.3-0.1-0.4-0.4-0.3-0.6c0.1-0.3,0.4-0.4,0.6-0.3 c0.2,0.1,0.5,0.1,0.8,0.1c1.3,0,2.4-1.1,2.4-2.5c0-0.2,0-0.5-0.1-0.7c-0.1-0.3,0.1-0.5,0.3-0.6c0.3-0.1,0.5,0.1,0.6,0.3 c0.1,0.3,0.1,0.7,0.1,1C11.3,10,9.8,11.6,7.9,11.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCmdHide16);
export default __webpack_public_path__ + "static/media/cmdHide16.7377ea7bf4891f02cfc11d8b6ae6b30b.svg";
export { ForwardRef as ReactComponent };